import { CSSProperties, MouseEventHandler } from 'react';
import { Lozenge } from 'shared/lozenge/Lozenge';
import { tokens } from 'styles/tokens';

type OverviewStatusLozengeProps = {
    children: React.ReactNode;
    /**
     * Text color of the lozenge (defaults to white)
     */
    color?: string;
    /**
     * Background color of the lozenge (defaults to blueGrey)
     */
    backgroundColor?: string;
    /**
     * Whether the text should be bold
     */
    isBold?: boolean;
    /**
     * Optional title (also used as ARIA Label)
     */
    title?: string;
    /**
     * Optional classname to apply to the Lozenge
     */
    className?: string;
    /**
     * Optional styles to apply to the Lozenge
     */
    style?: CSSProperties;
    /**
     * Optional callback for when the Lozenge is clicked
     */
    onClick?: MouseEventHandler<HTMLDivElement>;
    /**
     * Optional callback for removing the Lozenge
     */
    onRemove?: () => void;
};

export function OverviewStatusLozenge({
    children,
    color = tokens.text.onColor,
    backgroundColor = tokens.background.multicolorsDefault,
    isBold,
    title,
    className,
    style,
    onClick,
    onRemove,
}: OverviewStatusLozengeProps) {
    return (
        <Lozenge
            color={color}
            backgroundColor={backgroundColor}
            isBold={isBold}
            title={title}
            className={className}
            style={style}
            onClick={onClick}
            onRemove={onRemove}
        >
            {children}
        </Lozenge>
    );
}
